import { useEffect, type MutableRefObject } from 'react';
import type { CheckoutStep } from '@t/checkout.types';

const STICKY_HEADER_HEIGHT = 67;
const EXTRA_OFFSET = 20;
const DOM_SETTLE_DELAY_MS = 100;

export const useScrollToActiveStep = (
  activeStep: CheckoutStep,
  stepRefs: MutableRefObject<Record<string, HTMLDivElement | null>>
): void => {
  useEffect(() => {
    if (!activeStep) return;
    const el = stepRefs.current[activeStep];
    if (!el) return;

    const timer = setTimeout(() => {
      const top = el.getBoundingClientRect().top + window.scrollY - STICKY_HEADER_HEIGHT - EXTRA_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
    }, DOM_SETTLE_DELAY_MS);

    return () => clearTimeout(timer);
  }, [activeStep, stepRefs]);
};
